import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cadastro-pet',
  templateUrl: './cadastro-pet.component.html',
  styleUrls: ['./cadastro-pet.component.css']
})
export class CadastroPetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
